import i18n from 'i18n';
import {OperationStatus, UserStatus} from './types';

export const getOperationStatusLabel = (status: OperationStatus): string =>
    i18n.t(`status.${status.toLowerCase()}`, {ns: 'administration'});

export const getUserStatusLabel = (status: UserStatus): string =>
    i18n.t(`status.${status.toLowerCase()}`, {ns: 'administration'});

export const operationStatusColors = {
    [OperationStatus.SUCCESS]: 'text.primary',
    [OperationStatus.PROCESSING]: ' var(--mui-palette-text-disabled)',
    [OperationStatus.ERROR]: 'var(--mui-palette-error-main)',
};

export const userStatusColors = {
    [UserStatus.ACTIVE]: 'text.primary',
    [UserStatus.BLOCKED]: ' var(--mui-palette-error-main)',
};
